import { useEffect, useRef, useState } from "react";

export default function useChatNotifications() {
  const [unreadCount, setUnreadCount] = useState(0);
  const socketRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    // 🔊 Prepare sound
    audioRef.current = new Audio("/sounds/notification/notification.wav");

    // 🔌 Notification WebSocket
    socketRef.current = new WebSocket(
      "wss://backend.reportingbot.in/ws/chat/notifications/"
    );

    socketRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.event === "new_message" || data.event === "new_room") {
        setUnreadCount((prev) => prev + 1);

        // 🔔 Beep sound
        audioRef.current?.play().catch(() => {});
      }
    };

    socketRef.current.onerror = (err) => {
      console.error("Notification WS error", err);
    };

    return () => socketRef.current?.close();
  }, []);

  return {
    unreadCount,
    resetUnread: () => setUnreadCount(0),
  };
}
